module.exports = __webpack_public_path__ + "lato-black-webfont.96c3bb6f8d62d575da92.ttf";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-black-webfont.ttf
// module id = ../../../../../resources/fonts/lato-black-webfont.ttf
// module chunks = styles